import { render } from "./CreateEditPage.vue?vue&type=template&id=53832b0a"
import script from "./CreateEditPage.vue?vue&type=script&lang=js"
export * from "./CreateEditPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CreateEditPage.vue?vue&type=style&index=0&id=53832b0a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__